import { Box, Text } from '@mantine/core'
import { motion } from 'framer-motion'

import type { Heading } from 'src/hooks'

import {
  tocIndicator,
  tocItemHover,
  tocItemHoverTransition
} from '../animations'

type Props = {
  heading: Heading
  depth: number
  activeId: string
  registerRef: (id: string, el: HTMLDivElement | null) => void
  onScrollTo: (id: string) => void
}

export const HeadingItem = ({
  heading,
  depth,
  activeId,
  registerRef,
  onScrollTo
}: Props) => {
  const isActive = activeId === heading.id
  const pl = depth === 0 ? 'lg' : 32 + (depth - 1) * 12

  return (
    <Box>
      <Box
        ref={(el: HTMLDivElement | null) => registerRef(heading.id, el)}
        pos="relative"
        onClick={() => onScrollTo(heading.id)}
        style={{ cursor: 'pointer' }}
      >
        {isActive && (
          <motion.div
            className="toc-indicator"
            initial={tocIndicator.initial}
            animate={tocIndicator.animate}
            transition={tocIndicator.transition}
          />
        )}

        <motion.div
          whileHover={tocItemHover}
          transition={tocItemHoverTransition}
        >
          <Text
            size="md"
            c={isActive ? 'dark' : 'dimmed'}
            fw={isActive ? 500 : 400}
            lh={1.4}
            py={6}
            pl={pl}
          >
            {heading.text}
          </Text>
        </motion.div>
      </Box>

      {heading.children?.map((child) => (
        <HeadingItem
          key={child.id}
          heading={child}
          depth={depth + 1}
          activeId={activeId}
          registerRef={registerRef}
          onScrollTo={onScrollTo}
        />
      ))}
    </Box>
  )
}
